function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.94 11.6359C17.5898 11.6359 18.9835 10.1744 18.9835 8.28348C18.9835 6.43778 17.5823 5.02148 15.94 5.02148C14.3052 5.02148 12.8965 6.46038 12.904 8.29855C12.904 10.1744 14.2902 11.6359 15.94 11.6359ZM7.2313 11.8092C8.6702 11.8092 9.88309 10.5285 9.88309 8.88616C9.88309 7.274 8.65513 6.04604 7.2313 6.04604C5.80748 6.04604 4.57952 7.2966 4.58705 8.90123C4.58705 10.5285 5.79994 11.8092 7.2313 11.8092ZM3.08035 18.6496H8.73047C7.92438 17.4969 8.79073 15.2218 10.4933 13.8809C9.66462 13.346 8.58733 12.9542 7.2313 12.9542C3.86384 12.9542 1.68666 15.4328 1.68666 17.4743C1.68666 18.2201 2.06333 18.6496 3.08035 18.6496ZM11.2466 18.642H20.6334C21.8764 18.642 22.3058 18.2653 22.3058 17.5723C22.3058 15.6362 19.8424 12.9693 15.94 12.9693C12.0301 12.9693 9.57422 15.6362 9.57422 17.5723C9.57422 18.2653 10.0036 18.642 11.2466 18.642Z",
  fill: "#595959"
});

var SvgUserGroup = function SvgUserGroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 2 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-group.40373102.svg";
export { ForwardRef as ReactComponent };